export default __webpack_public_path__ + "static/media/Brinjal.07db3d53.jpg";